const sceneObj = {
  desert: require("../assets/public/images/scenery/desert.jpeg"),
  field: require("../assets/public/images/scenery/field.jpeg"),
  mountains: require("../assets/public/images/scenery/mountains.jpeg"),
  snow: require("../assets/public/images/scenery/snow.jpeg"),
  space: require("../assets/public/images/scenery/space.jpg"),
  swamp: require("../assets/public/images/scenery/swamp.jpeg"),
  background: require("../assets/public/images/sceneSelectBG.png"),
};

export { sceneObj };
